/* eslint-disable @typescript-eslint/ban-types */
import axios, { AxiosResponse } from 'axios'

const drupalInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_DRUPAL_API_URL,
  timeout: 15000,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': '*',
  },
})

const responseBody = (response: AxiosResponse) => response.data

const drupalHttp = {
  get: (url: string) => drupalInstance.get(url).then(responseBody),
  post: (url: string, body: {}) =>
    drupalInstance.post(url, body).then(responseBody),
  put: (url: string, body: {}) =>
    drupalInstance.put(url, body).then(responseBody),
  delete: (url: string) => drupalInstance.delete(url).then(responseBody),
}

export default drupalHttp
